// index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom"; // Import BrowserRouter
import "./index.css";
import MainRouter from "./MainRouter"; // Import MainRouter instead of App
import reportWebVitals from "./reportWebVitals";
import ScrollToTop from './components/ScrollToTop';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <MainRouter />
      <ScrollToTop /> 
       {/* Render MainRouter instead of App */}
    </BrowserRouter>
  </React.StrictMode>
);

// Performance measurement
reportWebVitals();